module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0109-language/language.component.css
// module id = ./src/app/a0109-language/language.component.css
// module chunks = main